import PropTypes from 'prop-types';

import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import { getBillsIncluded, getListingChips } from '../../../utils/listing';

import { isPlusPlan } from '../../../utils/plans';

import Tag from '../Tag';

import SpotahomeGuaranteeIcon from '../icons/SpotahomeGuaranteeIcon';

import CheckPropertyEyeIcon from '../icons/CheckPropertyEyeIcon';

import styles from './ValuePropositionTags.module.scss';

const ValuePropositionTags = ({
  className = '',
  titleClassName = '',
  title,
  securityDepositType,
  isInstantBooking,
  isBestChoice,
  bills,
  plan,
  verifiedLandlord = false,
  allowPermanentContract,
  onClickTag = null
}) => {
  const classes = classNames(styles['value-propsition-tags'], className);
  const titleClassNames = classNames(
    styles['value-propsition-tags__title'],
    titleClassName
  );
  const chips = getListingChips(
    securityDepositType === 'noSecurityDeposit',
    isInstantBooking,
    getBillsIncluded(bills),
    isBestChoice,
    isPlusPlan(plan),
    allowPermanentContract,
    verifiedLandlord
  );

  const handleClickTag = tag => () => {
    onClickTag(tag);
  };

  return (
    <div className={classes}>
      <div className={titleClassNames}>{title}</div>
      <div className={styles['value-propsition-tags__content']}>
        {chips.map(chip => (
          <Tag
            colorSchema={chip.colorSchema || 'tag'}
            size="small"
            key={chip.label}
            {...(onClickTag ? { onClick: handleClickTag(chip.id) } : {})}
            {...chip}
          />
        ))}
        <Tag
          label={trans('spotahome.guarantee.label').toUpperCase()}
          colorSchema="blue"
          size="small"
          renderLeadingIcon={() => <SpotahomeGuaranteeIcon />}
          isSpaced
          {...(onClickTag
            ? { onClick: handleClickTag('spotahomeGuarantee') }
            : {})}
        />
        <Tag
          label={trans('check.property.24h.label').toUpperCase()}
          colorSchema="blue"
          size="small"
          renderLeadingIcon={() => <CheckPropertyEyeIcon />}
          isSpaced
          {...(onClickTag
            ? { onClick: handleClickTag('checkProperty24h') }
            : {})}
        />
      </div>
    </div>
  );
};

ValuePropositionTags.propTypes = {
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  securityDepositType: PropTypes.string.isRequired,
  isInstantBooking: PropTypes.bool.isRequired,
  isBestChoice: PropTypes.bool.isRequired,
  bills: PropTypes.array.isRequired,
  plan: PropTypes.string.isRequired,
  verifiedLandlord: PropTypes.bool,
  allowPermanentContract: PropTypes.string.isRequired,
  onClickTag: PropTypes.func
};

export default ValuePropositionTags;
